<script setup lang="ts">
import type { ReadonlyDeep } from 'type-fest';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { computed } from 'vue';

export interface Props {
  stops?: ReadonlyDeep<openapi.AirroadJobDetailedContentOpenapi['stops']>;
  arStops?: Partial<openapi.AirroadSingleCreateBodyOpenapi['ar_stops'][0]>[];
  stopIndex?: number;
}
const props = withDefaults(defineProps<Props>(), {
  stops: () => [],
  arStops: () => [],
  stopIndex: undefined,
});

function getIsStopAddressEqualsSelectedAddress(
  stop: ReadonlyDeep<openapi.AirroadJobDetailedContentOpenapi['stops'][0]>,
  airRoadStop?: ReadonlyDeep<
    Partial<openapi.AirroadSingleCreateBodyOpenapi['ar_stops'][0]>
  >,
): boolean {
  if (!airRoadStop) return false;
  return (
    airRoadStop.address_line_1 === stop.address_line_1 &&
    airRoadStop.address_line_2 === stop.address_line_2 &&
    airRoadStop.name === stop.name &&
    airRoadStop.postcode === stop.post_code &&
    airRoadStop.state === stop.state &&
    airRoadStop.suburb === stop.suburb
  );
}

const stopAddressesIsOriginals = computed(function () {
  return props.stops.map(function (stop, stopIndex) {
    return getIsStopAddressEqualsSelectedAddress(
      stop,
      props.arStops[stopIndex],
    );
  });
});
</script>

<template>
  <div
    :class="$style.newAirRoadStopAddressText"
    data-testid="newAirRoadStopAddressText"
  >
    <p v-if="props.arStops[stopIndex]">
      {{ props.arStops[stopIndex].suburb }},
      {{ props.arStops[stopIndex].postcode }}
      <br />
      {{ props.arStops[stopIndex].address_line_1 }}
      {{ props.arStops[stopIndex].address_line_2 }}
    </p>
    <div v-if="!stopAddressesIsOriginals[stopIndex]">
      <h4>Original:</h4>
      <p>
        {{ stops[stopIndex].name }}, {{ stops[stopIndex].state }}
        <br />
        {{ stops[stopIndex].suburb }}, {{ stops[stopIndex].post_code }}
        <br />
        {{ stops[stopIndex].address_line_1 }}
        {{ stops[stopIndex].address_line_2 }}
      </p>
    </div>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.newAirRoadStopAddressText {
  font-size: 14px;
  line-height: 1.2;

  p {
    margin: 5px 0;
  }
  h4 {
    font-weight: 500;
    color: colors.$color-text-primary;
    margin: 5px 0;
  }
}
</style>
